import {NavigateAway} from '@staff-app/actions/experience.actions';
import {
  PortfolioActions,
  PortfolioActionTypes
} from '@staff-app/actions/portfolio.actions';
import {WorkHistoryAndPortfolioDTO} from '@staff-app/models/portfolioDTO';
import {CommonActions, CommonActionTypes} from '@store/actions/common.actions';
import {PortfolioFileGetDTO} from '@staff-app/models/portfolioDTO';

export interface State {
  workHistoryAndPortfolio: WorkHistoryAndPortfolioDTO;
  portfolioFiles: PortfolioFileGetDTO[];
}

export const initialState: State = {
  workHistoryAndPortfolio: null,
  portfolioFiles: null
};

export function reducer(
  state = initialState,
  action: PortfolioActions | CommonActions
): State {
  switch (action.type) {
    case PortfolioActionTypes.GetWorkHistoryAndPortfoliosSuccessful: {
      return {
        ...state,
        workHistoryAndPortfolio: action.payload
      };
    }
    case PortfolioActionTypes.SaveWorkHistoryAndPortfolios:
    case PortfolioActionTypes.NavigateAway:
    case CommonActionTypes.NavigateToSubmitPage: {
      return initialState;
      // remove store to prevent data load from cache
    }
    case PortfolioActionTypes.GetPortfolioFilesSuccessful: {
      return {
        ...state,
        portfolioFiles: action.payload
      };
    }
    default: {
      return state;
    }
  }
}

export const getWorkHistoryAndPortfolio = (state: State) =>
  state.workHistoryAndPortfolio;

export const getPortfolioFiles = (state: State) => state.portfolioFiles;
